export default __webpack_public_path__ + "static/media/materia_prima2.9a33263f.jpg";